import { dispatch } from '../store/'


export const fetchImpUsers = (impUsers) => {
    dispatch({type: 'FETCH_IMPORTEDUSERS', payload: impUsers})
}

export const fetchImpRequesters = (impUsers) => {
    return dispatch({type: 'FETCH_IMPORTED_REQUESTER', payload: impUsers})
}

export const fetchUnlockedUsers = (unlockedUsers) => {

    dispatch({type: 'FETCH_UNLOCKED_USERS', payload: unlockedUsers})
}

export const fetchUsersOnline = (usersOnline) => {
    dispatch({type: 'FETCH_USERS_ONLINE', payload: usersOnline})
}


// WEBPACK FOOTER //
// ./src/actions/adminUserMgm.js